// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"9e4bb7eb","108":"af971628","310":"eb0ca77d","344":"07c70e33","453":"2e67b4fb","659":"dc104305","843":"694f414f","925":"de768dd2"}[chunkId] + ".chunk.js";
};